export default __webpack_public_path__ + "static/media/logo.66822cbf.svg";